import { IMAGES, Reveal } from "./anim";

const CHAPTERS = [
  {
    n: "01",
    title: "The Architecture",
    body: "Every engagement starts with structure. We map your systems, expose the friction, and design an architecture that will still make sense three years from now.",
  },
  {
    n: "02",
    title: "The Craft",
    body: "We are engineers who care about the details nobody else notices — the clean commit, the graceful failure, the interface that just feels right.",
  },
  {
    n: "03",
    title: "The Partnership",
    body: "We don't disappear after launch. Quadrim stays embedded, monitoring, patching and evolving your technology as your business grows.",
  },
];

const STATS = [
  { value: "150+", label: "Systems managed" },
  { value: "99.98%", label: "Uptime delivered" },
  { value: "40+", label: "Products shipped" },
  { value: "8yrs", label: "Avg. partnership" },
];

export default function Manifesto() {
  return (
    <section
      id="studio"
      data-testid="studio-section"
      className="relative bg-[#0A0A0B] border-t border-white/10 py-24 md:py-32 px-6 md:px-10"
    >
      <div className="mx-auto max-w-[1600px]">
        <Reveal as="p" className="font-mono text-xs uppercase tracking-[0.25em] text-accent mb-16 md:mb-24">
          [ 02 ] — The Studio
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left: image */}
          <div className="lg:col-span-5">
            <Reveal className="relative overflow-hidden rounded-2xl border border-white/10 [clip-path:polygon(0_0,100%_0,100%_92%,0_100%)]">
              <img
                src={IMAGES.team}
                alt="The Quadrim Tech team"
                className="h-[420px] md:h-[560px] w-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
              />
            </Reveal>
            <div className="grid grid-cols-2 gap-4 mt-6">
              {STATS.map((s, i) => (
                <Reveal
                  key={s.label}
                  delay={i * 0.08}
                  className="rounded-xl border border-white/10 bg-surface p-5"
                >
                  <div className="font-heading text-3xl md:text-4xl font-black tracking-tight text-white">{s.value}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.15em] text-[#71717A] mt-1">{s.label}</div>
                </Reveal>
              ))}
            </div>
          </div>

          {/* Right: chapters */}
          <div className="lg:col-span-7 lg:pl-8">
            <Reveal as="h2" className="font-heading font-light uppercase tracking-tight text-3xl md:text-5xl leading-[1.02] mb-14 md:mb-20">
              We are not a vendor.<br />
              We are the team that <span className="text-accent">owns the outcome.</span>
            </Reveal>

            <div className="space-y-12 md:space-y-16">
              {CHAPTERS.map((c, i) => (
                <Reveal
                  key={c.n}
                  delay={i * 0.1}
                  className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 border-t border-white/10 pt-8"
                >
                  <div className="md:col-span-3 flex items-baseline gap-3">
                    <span className="font-mono text-sm text-accent">[{c.n}]</span>
                    <span className="font-heading text-2xl md:text-3xl font-medium tracking-tight">{c.title}</span>
                  </div>
                  <p className="md:col-span-9 text-[#A1A1AA] text-base md:text-lg leading-relaxed max-w-2xl">
                    {c.body}
                  </p>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
